import { useEffect, useState } from "react";
import { Phone } from "lucide-react";
import { BUSINESS, getOpenStatus } from "./data";

const LINKS = [
  { href: "#leistungen", label: "Leistungen", testid: "nav-link-leistungen" },
  { href: "#ablauf", label: "Ablauf", testid: "nav-link-ablauf" },
  { href: "#bewertungen", label: "Bewertungen", testid: "nav-link-bewertungen" },
  { href: "#kontakt", label: "Kontakt", testid: "nav-link-kontakt" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const status = getOpenStatus();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="header-navigation"
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color] duration-500 ${
        scrolled ? "glass-panel border-b border-white/10" : "border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
        <a
          href="#top"
          data-testid="brand-logo"
          className="font-display text-lg font-extrabold tracking-tight text-slate-50"
        >
          H<span className="text-blue-400">.</span>ELEKTRONIK
        </a>
        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              className="text-sm text-slate-400 transition-colors duration-300 hover:text-blue-400"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <span
            data-testid="header-open-status"
            className="hidden items-center gap-2 rounded-full border border-white/10 px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.18em] text-slate-300 lg:flex"
          >
            <span
              className={`h-1.5 w-1.5 rounded-full animate-pulse-dot ${
                status.open ? "bg-emerald-400" : "bg-blue-400"
              }`}
            />
            {status.label}
          </span>
          <a
            href={BUSINESS.phoneHref}
            data-testid="call-cta-button"
            className="group flex items-center gap-2 rounded-full bg-blue-400 px-4 py-2 text-sm font-semibold text-[#07080c] transition-colors duration-300 hover:bg-slate-50"
          >
            <Phone className="h-4 w-4 transition-transform duration-300 group-hover:rotate-12" />
            <span className="hidden sm:inline">{BUSINESS.phoneDisplay}</span>
          </a>
        </div>
      </div>
    </header>
  );
}
